import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Loader2, LogIn } from "lucide-react";
import { useAdmin } from "../admin/AdminAuth";

export default function AdminLogin() {
  const { login, admin } = useAdmin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (admin) navigate("/admin"); }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="admin-area min-h-screen grid place-items-center bg-[#0A3B2E] px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="font-display font-black text-2xl text-white">TJH</span>
            <span className="text-white/50 text-sm tracking-widest uppercase">Admin</span>
          </div>
          <h1 className="font-display font-bold text-3xl text-white">Welcome back</h1>
          <p className="text-white/50 mt-2 text-sm">Sign in to manage bookings & photos.</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-7 shadow-2xl space-y-4" data-testid="admin-login-form">
          <div className="relative">
            <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#16241E]/40" />
            <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email" className="w-full pl-11 pr-4 py-3 rounded-xl border border-[#0A3B2E]/15 focus:outline-none focus:ring-2 focus:ring-[var(--moss)]/40" />
          </div>
          <div className="relative">
            <Lock size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#16241E]/40" />
            <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password" className="w-full pl-11 pr-4 py-3 rounded-xl border border-[#0A3B2E]/15 focus:outline-none focus:ring-2 focus:ring-[var(--moss)]/40" />
          </div>
          {err && <p className="text-red-600 text-sm" data-testid="admin-login-error">{err}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit"
            className="w-full flex items-center justify-center gap-2 sunset-fill text-white font-bold py-3.5 rounded-xl disabled:opacity-70">
            {busy ? <><Loader2 size={18} className="animate-spin" /> Signing in...</> : <><LogIn size={18} /> Sign In</>}
          </button>
        </form>
      </div>
    </div>
  );
}
